module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "fm-title"
  }, [_c('span', {
    staticClass: "gbold"
  }, [_vm._v("CONTENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/fm02"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/fm03"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapt"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap01",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tno"
  }, [_vm._v("Day 1")]), _vm._v(" Remembering Why We Must Remember:")])]), _vm._v(" "), _c('p', {
    staticClass: "toci"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap01#ch1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "aitalic"
  }, [_vm._v("Why Forty Days?")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap02",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tno"
  }, [_vm._v("Day 2:")]), _vm._v(" Remembering Why We Must Remember:")])]), _vm._v(" "), _c('p', {
    staticClass: "toci"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap02#ch1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "aitalic"
  }, [_vm._v("Why Be Strong and Courageous?")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap03",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tno"
  }, [_vm._v("Day 3:")]), _vm._v(" Remembering Why We Must Remember:")])]), _vm._v(" "), _c('p', {
    staticClass: "toci"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap03#ch1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "aitalic"
  }, [_vm._v("Why Be a Stone Gatherer?")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap04",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tno"
  }, [_vm._v("Day 4:")]), _vm._v(" Remembering Why We Must Remember:")])]), _vm._v(" "), _c('p', {
    staticClass: "toci"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap04#ch1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "aitalic"
  }, [_vm._v("Gathering Stones—or Pecans")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap05",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tno"
  }, [_vm._v("Day 5")]), _vm._v(" Remembering Why:")])]), _vm._v(" "), _c('p', {
    staticClass: "toci"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap05#ch1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "aitalic"
  }, [_vm._v("Forty Days of Remembering")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap06",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tno"
  }, [_vm._v("Day 6")]), _vm._v(" Remembering Who He Is:")])]), _vm._v(" "), _c('p', {
    staticClass: "toci"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap06#ch1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "aitalic"
  }, [_vm._v("The Cornerstone")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap07",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tno"
  }, [_vm._v("Day 7")]), _vm._v(" Remembering Who He Is:")])]), _vm._v(" "), _c('p', {
    staticClass: "toci"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap07#ch1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "aitalic"
  }, [_vm._v("King of Kings")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap08",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tno"
  }, [_vm._v("Day 8")]), _vm._v(" Remembering Who He Is:")])]), _vm._v(" "), _c('p', {
    staticClass: "toci"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap08#ch1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "aitalic"
  }, [_vm._v("Lord of Lords")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap09",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tno"
  }, [_vm._v("Day 9")]), _vm._v(" Remembering Who He Is:")])]), _vm._v(" "), _c('p', {
    staticClass: "toci"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap09#ch1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "aitalic"
  }, [_vm._v("The Holy One")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tno"
  }, [_vm._v("Day 10")]), _vm._v(" Remembering Who He Is:")])]), _vm._v(" "), _c('p', {
    staticClass: "toci"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap10#ch1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "aitalic"
  }, [_vm._v("The Savior")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tno"
  }, [_vm._v("Day 11")]), _vm._v(" Remembering Who He Is:")])]), _vm._v(" "), _c('p', {
    staticClass: "toci"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap11#ch1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "aitalic"
  }, [_vm._v("Wonderful Counselor")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap12",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tno"
  }, [_vm._v("Day 12")]), _vm._v(" Remembering Who He Is:")])]), _vm._v(" "), _c('p', {
    staticClass: "toci"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap12#ch1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "aitalic"
  }, [_vm._v("Mighty God")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap13",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tno"
  }, [_vm._v("Day 13")]), _vm._v(" Remembering Who He Is:")])]), _vm._v(" "), _c('p', {
    staticClass: "toci"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap13#ch1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "aitalic"
  }, [_vm._v("The Almighty")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap14",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tno"
  }, [_vm._v("Day 14")]), _vm._v(" Remembering Who He Is:")])]), _vm._v(" "), _c('p', {
    staticClass: "toci"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap14#ch1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "aitalic"
  }, [_vm._v("The Prince of Peace")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap15",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tno"
  }, [_vm._v("Day 15")]), _vm._v(" Remembering Who He Is:")])]), _vm._v(" "), _c('p', {
    staticClass: "toci"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap15#ch1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "aitalic"
  }, [_vm._v("The Everlasting Father")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap16",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tno"
  }, [_vm._v("Day 16")]), _vm._v(" Remembering What He Has Promised:")])]), _vm._v(" "), _c('p', {
    staticClass: "toci"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap16#ch1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "aitalic"
  }, [_vm._v("Salvation")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap17",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tno"
  }, [_vm._v("Day 17")]), _vm._v(" Remembering What He Has Promised:")])]), _vm._v(" "), _c('p', {
    staticClass: "toci"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap17#ch1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "aitalic"
  }, [_vm._v("The Holy Spirit")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap18",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tno"
  }, [_vm._v("Day 18")]), _vm._v(" Remembering What He Has Promised:")])]), _vm._v(" "), _c('p', {
    staticClass: "toci"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap18#ch1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "aitalic"
  }, [_vm._v("Covenantal Love")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap19",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tno"
  }, [_vm._v("Day 19")]), _vm._v(" Remembering What He Has Promised:")])]), _vm._v(" "), _c('p', {
    staticClass: "toci"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap19#ch1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "aitalic"
  }, [_vm._v("Forgiveness")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap20",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tno"
  }, [_vm._v("Day 20")]), _vm._v(" Remembering What He Has Promised:")])]), _vm._v(" "), _c('p', {
    staticClass: "toci"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap20#ch1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "aitalic"
  }, [_vm._v("Protection")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap21",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tno"
  }, [_vm._v("Day 21")]), _vm._v(" Remembering What He Has Promised:")])]), _vm._v(" "), _c('p', {
    staticClass: "toci"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap21#ch1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "aitalic"
  }, [_vm._v("Heaven")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap22",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tno"
  }, [_vm._v("Day 22")]), _vm._v(" Remembering What He Has Promised:")])]), _vm._v(" "), _c('p', {
    staticClass: "toci"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap22#ch1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "aitalic"
  }, [_vm._v("He Will Supply Our Needs")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap23",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tno"
  }, [_vm._v("Day 23")]), _vm._v(" Remembering What He Has Promised:")])]), _vm._v(" "), _c('p', {
    staticClass: "toci"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap23#ch1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "aitalic"
  }, [_vm._v("He Will Contend")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap24",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tno"
  }, [_vm._v("Day 24")]), _vm._v(" Remembering What He Has Promised:")])]), _vm._v(" "), _c('p', {
    staticClass: "toci"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap24#ch1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "aitalic"
  }, [_vm._v("Guidance")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap25",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tno"
  }, [_vm._v("Day 25")]), _vm._v(" Remembering What He Has Promised:")])]), _vm._v(" "), _c('p', {
    staticClass: "toci"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap25#ch1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "aitalic"
  }, [_vm._v("New Creations")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap26",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tno"
  }, [_vm._v("Day 26")]), _vm._v(" Remembering What He Has Promised:")])]), _vm._v(" "), _c('p', {
    staticClass: "toci"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap26#ch1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "aitalic"
  }, [_vm._v("His Promises Are True")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap27",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tno"
  }, [_vm._v("Day 27")]), _vm._v(" Remember What He Has Instructed:")])]), _vm._v(" "), _c('p', {
    staticClass: "toci"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap27#ch1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "aitalic"
  }, [_vm._v("Praise")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap28",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tno"
  }, [_vm._v("Day 28")]), _vm._v(" Remember What He Has Instructed:")])]), _vm._v(" "), _c('p', {
    staticClass: "toci"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap28#ch1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "aitalic"
  }, [_vm._v("Serve Others")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap29",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tno"
  }, [_vm._v("Day 29")]), _vm._v(" Remember What He Has Instructed:")])]), _vm._v(" "), _c('p', {
    staticClass: "toci"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap29#ch1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "aitalic"
  }, [_vm._v("Believe")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap30",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tno"
  }, [_vm._v("Day 30")]), _vm._v(" Remember What He Has Instructed:")])]), _vm._v(" "), _c('p', {
    staticClass: "toci"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap30#ch1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "aitalic"
  }, [_vm._v("Be Still")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap31",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tno"
  }, [_vm._v("Day 31")]), _vm._v(" Remember What He Has Instructed:")])]), _vm._v(" "), _c('p', {
    staticClass: "toci"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap31#ch1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "aitalic"
  }, [_vm._v("Obey")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap32",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tno"
  }, [_vm._v("Day 32")]), _vm._v(" Remember What He Has Instructed:")])]), _vm._v(" "), _c('p', {
    staticClass: "toci"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap32#ch1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "aitalic"
  }, [_vm._v("Encourage One Another")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap33",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tno"
  }, [_vm._v("Day 33")]), _vm._v(" Remember What He Has Instructed:")])]), _vm._v(" "), _c('p', {
    staticClass: "toci"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap33#ch1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "aitalic"
  }, [_vm._v("Be Hospitable")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap34",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tno"
  }, [_vm._v("Day 34")]), _vm._v(" Remember What He Has Done:")])]), _vm._v(" "), _c('p', {
    staticClass: "toci"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap34#ch1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "aitalic"
  }, [_vm._v("He Said Yes")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap35",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tno"
  }, [_vm._v("Day 35")]), _vm._v(" Remember What He Has Done:")])]), _vm._v(" "), _c('p', {
    staticClass: "toci"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap35#ch1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "aitalic"
  }, [_vm._v("He Calls Us by Name")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap36",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tno"
  }, [_vm._v("Day 36")]), _vm._v(" Remember What He Has Done:")])]), _vm._v(" "), _c('p', {
    staticClass: "toci"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap36#ch1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "aitalic"
  }, [_vm._v("He Has Accomplished Everything")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap37",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tno"
  }, [_vm._v("Day 37")]), _vm._v(" Remember What He Has Done:")])]), _vm._v(" "), _c('p', {
    staticClass: "toci"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap37#ch1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "aitalic"
  }, [_vm._v("He Forgave")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap38",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tno"
  }, [_vm._v("Day 38")]), _vm._v(" Remember What He Has Done:")])]), _vm._v(" "), _c('p', {
    staticClass: "toci"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap38#ch1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "aitalic"
  }, [_vm._v("He Crushed the Enemy’s Head")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap39",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tno"
  }, [_vm._v("Day 39")]), _vm._v(" Remember What He Has Done:")])]), _vm._v(" "), _c('p', {
    staticClass: "toci"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap39#ch1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "aitalic"
  }, [_vm._v("He Wore the Thorns")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap40",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tno"
  }, [_vm._v("Day 40")]), _vm._v(" Remember What He Has Done:")])]), _vm._v(" "), _c('p', {
    staticClass: "toci"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap40#ch1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "aitalic"
  }, [_vm._v("He Said Yes")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fmt"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/bm01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/bm02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/bm03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a01b224c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/toc.vue
// module id = 72
// module chunks = 0